import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Layout/Footer";
import BeyondNav from "../Components/Layout/BeyondNav";
import NavBar from "../Components/Layout/NavBar";

export default function SharedLayout() {
  const [scroll, setScroll] = useState(false);

  const scrollUp = () => {
    window.scrollTo(0, 0);
  };

  const scrollMeasure = () => {
    if (window.scrollY > 300) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", scrollMeasure);

    return () => {
      window.removeEventListener("scroll", scrollMeasure);
    };
  }, []);
  return (
    <>
      <BeyondNav />
      {/* <NavBar /> */}
      <Outlet />
      <Footer />
      <button className={scroll ? "Scroll" : "no-display"} onClick={scrollUp}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          fill="white"
          className="bi bi-arrow-up-short"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 12a.5.5 0 0 0 .5-.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 .5.5z"
          />
        </svg>
      </button>
    </>
  );
}
